import React from "react";

const GLgroup = () => {

  return <div>GLgroup</div>;
};

export default GLgroup;
